export default __webpack_public_path__ + "static/media/salary-tmp.0e6406bf.png";